import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ExpansionPanel from '../../../components/SolvPatternLibrary/ExpansionPanel';
import AboutCard from '../AboutCard';
import Photos from './Photos';
import SelfPay from './SelfPay';
import InsuranceAndPayments from './InsuranceAndPayments';
import Services from './Services';
import MapAndDirections from './MapAndDirections/MapAndDirectionsContainer';
import Reviews from './Reviews';

class Sections extends PureComponent {
  render() {
    const {
      enableCollapsing,
      location,
      handleOpenCarousel,
      viewport,
      defaultExpanded,
      nearbyLocations,
      showModal,
      sessionTrackingProperties,
    } = this.props;
    const sectionBaseProps = {
      enableCollapsing,
      location,
      defaultExpanded,
      sessionTrackingProperties,
    };

    return (
      <ExpansionPanel>
        <AboutCard nearbyLocations={nearbyLocations} {...sectionBaseProps} />
        <MapAndDirections {...sectionBaseProps} />
        <SelfPay {...sectionBaseProps} />
        <Services {...sectionBaseProps} />
        <InsuranceAndPayments {...sectionBaseProps} />
        <Photos handleOpenCarousel={handleOpenCarousel} viewport={viewport} {...sectionBaseProps} />
        <Reviews {...sectionBaseProps} showModal={showModal} />
      </ExpansionPanel>
    );
  }
}

Sections.propTypes = {
  enableCollapsing: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  location: PropTypes.object,
  nearbyLocations: PropTypes.object,
  handleOpenCarousel: PropTypes.func,
  viewport: PropTypes.object,
  showModal: PropTypes.func,
  sessionTrackingProperties: PropTypes.object,
};

export default Sections;
